<template>
  <div v-if="shiftPastList.length > 0 && user.role !== 'customer'">
    <hr>
    <b-row>
      <!-- Shifts past  -->
      <b-col
        cols="12"
      >
        <div
          style="height: 35px; margin-bottom: 30px"
        >
          <h4
            class="text-center"
            style="color: #8d949d; font-weight: 300"
          >
            {{ $t('action_center.confirmation_completed_Header') }}
          </h4>
        </div>
        <div v-if="areaIdShiftPastList">
          <b-modal
            id="confirmedShiftPastModal"
            :title="$t('action_center.sendShiftsForInspection')"
            @hidden="resetModal"
          >
            <div>
              <v-select
                v-if="formVerifiedShifts.data.length >= 1"
                v-model="formVerifiedShifts.emails"
                multiple
                taggable
                :no-drop="true"
                style="text-transform: lowercase"
                :placeholder="`${$t('action_center.email_placeholder') }`"
              />
              <small
                v-if="!formVerifiedShifts.emails.length"
                class="text-danger"
              >
                {{ $t('action_center.client_email_warning') }}
              </small>
            </div>

            <div
              v-if="formVerifiedShifts.data.length >= 1"
              class="mt-2"
            >
              <b-card
                v-for="shift in formVerifiedShifts.data"
                :key="shift.id"
                class="border-b-2 py-2"
              >
                <app-collapse>
                  <app-collapse-item
                    :title="`${shift.user.fullName} | ${shift.start.toLocaleString('fi', {month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}) } - ${shift.end.toLocaleString('fi', {hour: 'numeric', minute: 'numeric'}) }`"
                    class="capitalized d-flex justify-space-between"
                  >
                    <b-card-text>{{ $t('action_center.assigned_label') }} : {{ shift.user.fullName }}</b-card-text>
                    <b-card-text>{{ $t('action_center.role') }} : {{ shift.user.role }}</b-card-text>
                    <b-card-text>{{ $t('action_center.permission') }} : {{ shift.user.love ? $t('action_center.permissible') : $t('action_center.unauthorized') }}</b-card-text>
                    <b-card-text>{{ $t('action_center.started_str') }} : {{ shift.start.toLocaleString('fi', {month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}) }}</b-card-text>
                    <b-card-text>{{ $t('action_center.ended_str') }} : {{ shift.end.toLocaleString('fi', {month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}) }}</b-card-text>
                  </app-collapse-item>
                </app-collapse>

              </b-card>
            </div>
            <template #modal-footer="{}">
              <b-button
                v-if="user.role !== 'customer'"
                variant="primary"
                :disabled="!formVerifiedShifts.emails.length || sendingVerification"
                @click="onSendShiftInspection()"
              >
                {{ $t('action_center.send') }}
              </b-button>
            </template>
          </b-modal>

          <b-modal
            id="confirmExpired"
            :title="$t('confirmation')"
            :ok-title="$t('ok')"
            :cancel-title="$t('cancel')"
            ok-variant="danger"
            cancel-variant="outline-secondary"
            modal-class="modal-danger"
            centered
            @ok="handleExpiredShiftPast"
          >
            <p class="my-2">
              {{ $t('action_center.shiftPast.confirm_expired') }}
            </p>
          </b-modal>

          <b-modal
            id="handleConfirm"
            :title="$t('confirmation')"
            :ok-title="$t('ok')"
            :cancel-title="$t('cancel')"
            cancel-variant="outline-secondary"
            centered
            @ok="handleConfirmShiftPast"
          >
            <p class="my-2">
              {{ $t('action_center.shiftPast.confirm_message') }}
            </p>
          </b-modal>

          <b-card
            v-for="areaId in areaIdShiftPastList"
            :key="areaId"
            class="text-capitalize w-full"
          >
            <template #header>
              <div class="header-container">
                <span class="font-weight-bold header-title">
                  {{ getShiftPastByAreaId(areaId).pop().area.name }}
                </span>
                <div style="display: flex">
                  <b-button
                    v-if="user.role !== 'customer'"
                    type="button"
                    style="margin-right: 10px"
                    variant="info"
                    class="header-button"
                    :disabled="!selectedShiftsOfArea(areaId) || selectedShiftsOfArea(areaId).length < 1"
                    @click="confirmShiftsPastByAreaId(areaId)"
                  >
                    {{ $t('action_center.shiftPast.sendConfirmation') }}
                  </b-button>
                  <b-button
                    v-b-modal.confirmExpired
                    type="button"
                    style="margin-right: 10px"
                    variant="danger"
                    class="header-button"
                    :disabled="!selectedShiftsOfArea(areaId) || selectedShiftsOfArea(areaId).length < 1"
                    @click="selectedAreaIdPastShifts = areaId"
                  >
                    {{ $t('action_center.shiftPast.cancel_Shift') }}
                  </b-button>
                  <b-button
                    v-b-modal.handleConfirm
                    type="button"
                    variant="primary"
                    class="header-button"
                    :disabled="!selectedShiftsOfArea(areaId) || selectedShiftsOfArea(areaId).length < 1"
                    @click="selectedAreaIdPastShifts = areaId"
                  >
                    {{ $t('action_center.shiftPast.confirmShifts') }}
                  </b-button>
                </div>
              </div>
            </template>
            <div
              v-for="week in areaWeeksList[areaId]"
              :key="week"
            >
              <b-table
                :ref="'table_'+ areaId + '_' + week"
                class="position-relative"
                style="margin-bottom: 20px"
                :items="getShiftPastByAreaIdAndWeek(areaId, week)"
                responsive
                :fields="tableColumns"
                primary-key="id"
                show-empty
                selectable
                :empty-text="$t('no_matching_records')"
                @row-selected="(items) => onRowSelected(areaId, week, items)"
              >
                <template #head(selected)>
                  <b-form-checkbox
                    @change="(checked) => selectAll(areaId, week, checked)"
                  >
                    {{ $t('action_center.week') }} #{{ week }}
                  </b-form-checkbox>
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">{{ $t('action_center.selected') }}</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">{{ $t('action_center.not_selected') }}</span>
                  </template>
                </template>
                <template #cell(user)="data">
                  <span
                    class="font-weight-bold"
                  >
                    {{ data.value.firstName }} {{ data.value.lastName }}
                  </span>
                </template>
                <template #cell(date)="data">
                  <span
                    class="font-weight-bold"
                  >
                    {{ data.item.start.toLocaleString('fi', {month: 'short', day: 'numeric'}) }}
                  </span>
                </template>
                <template #cell(start)="data">
                  <span
                    class="font-weight-bold"
                  >
                    {{ data.value.toLocaleString('fi', {hour: 'numeric', minute: 'numeric'}) }}
                  </span>
                </template>
                <template #cell(end)="data">
                  <span
                    class="font-weight-bold"
                  >
                    {{ data.value.toLocaleString('fi', {hour: 'numeric', minute: 'numeric'}) }}
                  </span>
                </template>
                <template #cell(finalConfirmation)="data">
                  <a
                    v-if="data.value.ticketId"
                    :href="`https://hoiwa.zendesk.com/agent/tickets/${data.value.ticketId}`"
                    target="_blank"
                    class="font-weight-bold"
                  >
                    #{{ data.value.ticketId }}
                  </a>
                </template>
                <template #cell(action)="data">
                  <b-button
                    v-b-modal.update-shift-modal
                    variant="link"
                    @click="selectedShift = {...data.item}"
                  >
                    {{ $t('action_center.shiftPast.change_time') }}
                  </b-button>
                </template>
              </b-table>
            </div>
          </b-card>
        </div>
      </b-col>
      <b-modal
        id="update-shift-modal"
        title="Update shift time"
        ok-title="Save changes"
        @ok="handleUpdateShiftTime"
      >
        <validation-observer ref="rules">
          <b-form
            ref="form"
            @submit.stop.prevent="handleSubmit"
          >
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="$t('gig_page.start')"
                  label-for="start"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('gig_page.start')"
                    rules="required"
                  >
                    <flat-pickr
                      v-model="selectedShift.startStr"
                      :state="errors.length > 0 ? false : null"
                      :config="{ enableTime: true, time_24hr: true }"
                      class="form-control"
                      @on-change="(date) => { setDate(selectedShift, date, 'start') }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                class="shift-end"
              >
                <b-form-group
                  :label="$t('gig_page.end')"
                  label-for="end"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('gig_page.end')"
                    rules="required"
                  >
                    <flat-pickr
                      v-model="selectedShift.endStr"
                      class="form-control"
                      :config="{ enableTime: true, time_24hr: true }"
                      :state="errors.length > 0 ? false : null"
                      @on-change="(date) => { setDate(selectedShift, date, 'end') }"
                    />
                    <small
                      v-if="errors[0]"
                      class="text-danger"
                    >
                      {{ errors[0] }}
                    </small>
                    <small
                      v-else-if="selectedShift.startStr && selectedShift.endStr && (selectedShift.startStr.slice(0, 10) !== selectedShift.endStr.slice(0, 10))"
                      class="text-warning"
                    >
                      {{ $t('gig_page.shift_diff_date_warning') }}
                      <feather-icon
                        icon="AlertTriangleIcon"
                        class="margin-left:5px;"
                        size="12"
                      />
                    </small>

                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
      <!-- End shifts past  -->
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BButton,
  BTable,
  BForm,
  BFormGroup,
  BFormCheckbox,
  BRow,
  BCol,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContentVue from '@hw-ui/components/toastification/ToastificationContent.vue'
import AppCollapse from '@hw-ui/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@hw-ui/components/app-collapse/AppCollapseItem.vue'
import vSelect from 'vue-select'
import { required } from '@validations'

function getNumberOfWeek(date) {
  const tdt = new Date(date.valueOf())
  const dayn = (date.getDay() + 6) % 7
  tdt.setDate(tdt.getDate() - dayn + 3)
  const firstThursday = tdt.valueOf()
  tdt.setMonth(0, 1)
  if (tdt.getDay() !== 4) {
    // eslint-disable-next-line no-mixed-operators
    tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7)
  }
  return 1 + Math.ceil((firstThursday - tdt) / 604800000)
}

function addShiftToTable(shift) {
  /* eslint-disable quotes */
  /* eslint-disable prefer-template */
  const { user } = shift
  const { fullName } = user
  const start = shift.start.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
  const end = shift.end.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
  const date = shift.start.toLocaleString('fi', { month: 'numeric', day: 'numeric' })
  const message = `
                  <tr>
                  <td style="text-transform:capitalize">` + fullName + `</td>
                  <td>` + date + `</td>
                  <td>` + start + `</td>
                  <td>` + end + `</td>
                  <td> V | X </td>
                  </tr>
              `

  return message
}

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    BCard,
    BCardText,
    BButton,
    BTable,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BRow,
    BCol,

    ValidationProvider,
    ValidationObserver,
    flatPickr,
    vSelect,
  },

  props: {
    processer: {
      type: Object,
      default: () => {},
    },
    user: {
      type: Object,
      default: () => {},
    },
    createConfirmationTicket: {
      type: Function,
      required: true,
    },
    createClientRequest: {
      type: Function,
      required: true,
    },
    updateShift: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      required,
      formVerifiedShifts: {
        areaId: null,
        shiftId: null,
        data: [],
        emails: [],
      },
      tableColumns: [
        { key: 'selected', label: this.$t('choose') },
        { key: 'user', label: this.$t('shift_worker'), sortable: false },
        { key: 'date', label: this.$t('date'), sortable: false },
        { key: 'start', label: this.$t('started'), sortable: false },
        { key: 'end', label: this.$t('ended'), sortable: false },
        { key: 'action', label: '', sortable: false },
      ],
      shiftPastList: [],
      areaIdShiftPastList: [],
      areaWeeksList: [],
      selectedAreaIdPastShifts: null,
      selectedPastShifts: [],
      sendingVerification: false,
      selectedShift: {},
    }
  },

  created() {
    this.$emit('fetchShiftPast', shifts => {
      shifts.forEach(data => {
        const weekNumber = getNumberOfWeek(data.start.toDate())
        this.shiftPastList.unshift({
          ...data,
          start: data.start.toDate(),
          end: data.end.toDate(),
        })
        if (this.areaIdShiftPastList && this.areaIdShiftPastList.indexOf(data.areaId) === -1) {
          this.areaIdShiftPastList.push(data.areaId)
        }
        if (!this.areaWeeksList[data.areaId]) {
          this.areaWeeksList[data.areaId] = [weekNumber]
        } else if (this.areaWeeksList[data.areaId].indexOf(weekNumber) === -1) {
          this.areaWeeksList[data.areaId].push(weekNumber)
        }
      })
    })
  },

  methods: {
    onConvertDate(date) {
      const convertedDate = new Date(date)
      return (`${
        convertedDate.getFullYear().toString().padStart(4, '0')}-${
        (convertedDate.getMonth() + 1).toString().padStart(2, '0')}-${
        convertedDate.getDate().toString().padStart(2, '0')} ${
        convertedDate.getHours().toString().padStart(2, '0')}:${
        convertedDate.getMinutes().toString().padStart(2, '0')}`
      )
    },
    setDate(item, date, slot) {
      /* eslint-disable no-param-reassign */
      if (slot === 'start') {
        [item.start] = date
        if (item.start > item.end) {
          const dt = new Date(date)
          dt.setHours(dt.getHours() + 8)
          item.end = dt
          item.endStr = this.onConvertDate(dt)
        }
      } else {
        [item.end] = date
      }
      /* eslint-enable no-param-reassign */
    },
    getShiftPastByAreaId(areaId) {
      return this.shiftPastList
        .filter(item => item.areaId === areaId)
        .sort((a, b) => {
          const c = new Date(a.start)
          const d = new Date(b.start)
          return c - d
        })
    },

    getShiftPastByAreaIdAndWeek(areaId, week) {
      return this.shiftPastList
        .filter(item => item.areaId === areaId && getNumberOfWeek(item.start) === week)
        .sort((a, b) => {
          const c = new Date(a.start)
          const d = new Date(b.start)
          return c - d
        })
    },

    confirmShiftsPastByAreaId(areaId) {
      this.formVerifiedShifts.areaId = areaId
      this.formVerifiedShifts.data = this.selectedShiftsOfArea(areaId)
      const { area } = this.formVerifiedShifts.data[0]
      this.formVerifiedShifts.emails = area.confirmation_emails && area.confirmation_emails.length > 0 ? area.confirmation_emails : area.emails
      this.formVerifiedShifts.emails = this.formVerifiedShifts.emails ? this.formVerifiedShifts.emails : []
      this.$bvModal.show('confirmedShiftPastModal')
    },

    createNewInspectionTicketMessage(shifts) {
      let message = ''
      const messageStart = `<p>Hei,</p>
                  <p>Pyydämme teiltä vahvistusta alla mainittuihin vuoroihin. Tarvitsemme vuorojen vahvistuksen laskutusta sekä palkanmaksua varten.</p>
                  <p><b>Voitte kopioida taulukon ja merkitä V (Suoritettu) tai X (Ei suoritettu). Jos vuoro on suoritettu, mutta alkamis- tai loppumisaika on eri, voitte kirjata myös sen taulukkoon.</b></p>`
      message += messageStart
      const weeks = Array.from(new Set(this.formVerifiedShifts.data.map(shift => getNumberOfWeek(shift.start))))
      const shiftsInWeeks = weeks.map(week => shifts.filter(shift => getNumberOfWeek(shift.start) === week))
      message += shiftsInWeeks.map(s => {
        if (!s || s.length < 1) { return '' }
        let tables = ''
        const week = getNumberOfWeek(s[0].start)
        const weekTableStart = `
                  <table style="margin-bottom: 10px">
                  <tr>
                    <th>${this.$t('week')}: ${week}</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                  <th>${this.$t('shift_worker')}</th>
                  <th>Pvm</th>
                  <th>${this.$t('started')}</th>
                  <th>${this.$t('ended')}</th>
                  <th>${this.$t('completed')} (V) | ${this.$t('not_completed')} (X)</th>
                  </tr>
                  `
        tables += weekTableStart
        s.forEach(shift => {
          tables += addShiftToTable(shift)
        })
        const weekTableEnd = `
                  </table>`
        tables += weekTableEnd
        return tables
      }).join('')
      const messageEnd = `
                  <p>Voitte antaa vastauksenne vastaamalla tähän viestiin.
                  <p>Ystävällisin terveisin,</p>
                  <p>Hoiwa ‑tiimi</p>`

      message += messageEnd
      return message
    },

    async onSendShiftInspection() {
      this.sendingVerification = true
      const to = this.formVerifiedShifts.emails
      const areaName = this.formVerifiedShifts.data[0].area.name
      const weeks = new Set(this.formVerifiedShifts.data.map(shift => getNumberOfWeek(shift.start)))
      const subject = this.capitalize(areaName) + ' - Suoritettujen vuorojen tarkistus - Viikot: ' + Array.from(weeks).join(', ')
      const shifts = this.formVerifiedShifts.data
      if (shifts.length < 1) {
        return
      }
      try {
        // Create ticket
        const message = this.createNewInspectionTicketMessage(shifts)
        const result = await this.createConfirmationTicket({
          requester: this.processer.email,
          groupId: '4415022971153',
          message,
          collaborators: to,
          subject,
        })
        // Create client request
        const ticketId = result.id
        const response = await this.createClientRequest({
          ticketId: result.id,
          processer: `${this.processer.firstName} ${this.processer.lastName}`,
          type: 'shifts_confirmation',
          status: 'open',
          updates: 0,
          name: this.capitalize(areaName) + ' - Suoritettujen vuorojen tarkistus - Viikot: ' + Array.from(weeks).join(', '),
        })
        // Add client request and ticket id to shifts
        await Promise.all(shifts.map(async shift => {
          const updates = shift.updates ? shift.updates : []
          const finalConfirmation = {
            ...shift.finalConfirmation,
            sent: true,
            ticketId,
            sentTime: new Date(),
            sender: {
              firstName: this.processer.firstName,
              lastName: this.processer.lastName,
            },
          }
          const update = {
            processer: `${this.processer.firstName} ${this.processer.lastName}`,
            date: new Date(),
            state: 'shift check',
            content: ['shift check: created', `Ticket: #${ticketId}`],
          }
          updates.push(update)
          const confirmationRequest = response
          await this.updateShift({ id: shift.id, updates: { confirmationRequest, updates, finalConfirmation } })
        }))
        this.sendingVerification = false
        this.$bvModal.hide('confirmedShiftPastModal')
        this.shiftPastList = this.shiftPastList.filter(shift => !shifts.some(s => s.id === shift.id))
        this.$toast({
          component: ToastificationContentVue,
          position: 'top-right',
          props: {
            title: this.$t('success'),
            text: this.$t('action_center.toast_message.confirm_past_shifts_success'),
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (e) {
        this.$toast({
          component: ToastificationContentVue,
          position: 'top-right',
          props: {
            title: this.$t('error'),
            text: this.$t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },

    async handleExpiredShiftPast() {
      const shifts = this.selectedShiftsOfArea(this.selectedAreaIdPastShifts)
      await Promise.all(shifts.map(async shift => {
        const updates = shift.updates ? shift.updates : []
        const update = {
          processer: `${this.processer.firstName} ${this.processer.lastName}`,
          date: new Date(),
          state: 'shift expired',
        }
        updates.push(update)
        await this.updateShift({ id: shift.id, updates: { updates, status: 'expired' } })
      }))
      this.shiftPastList = this.shiftPastList.filter(shift => !shifts.some(s => s.id === shift.id))
      this.areaIdShiftPastList = []
      this.shiftPastList.forEach(shift => {
        if (this.areaIdShiftPastList && this.areaIdShiftPastList.indexOf(shift.areaId) === -1) {
          this.areaIdShiftPastList.push(shift.areaId)
        }
      })
    },

    async handleConfirmShiftPast() {
      const shifts = this.selectedShiftsOfArea(this.selectedAreaIdPastShifts)
      await Promise.all(shifts.map(async shift => {
        const updates = shift.updates ? shift.updates : []
        const update = {
          processer: `${this.processer.firstName} ${this.processer.lastName}`,
          date: new Date(),
          state: 'shift confirmed',
        }
        updates.push(update)
        const finalConfirmation = { ...shift.finalConfirmation, confirmed: true }
        await this.updateShift({ id: shift.id, updates: { updates, status: 'confirmed', finalConfirmation } })
      }))
      this.shiftPastList = this.shiftPastList.filter(shift => !shifts.some(s => s.id === shift.id))
      this.areaIdShiftPastList = []
      this.shiftPastList.forEach(shift => {
        if (this.areaIdShiftPastList && this.areaIdShiftPastList.indexOf(shift.areaId) === -1) {
          this.areaIdShiftPastList.push(shift.areaId)
        }
      })
    },

    selectAll(areaId, week, checked) {
      if (checked) {
        this.$refs[`table_${areaId}_${week}`][0].selectAllRows()
      } else {
        this.$refs[`table_${areaId}_${week}`][0].clearSelected()
      }
    },

    onRowSelected(areaId, week, items) {
      this.selectedPastShifts = { ...this.selectedPastShifts }
      this.selectedPastShifts[areaId] = { ...this.selectedPastShifts[areaId] }
      this.selectedPastShifts[areaId][week] = items
    },

    selectedShiftsOfArea(areaId) {
      if (this.selectedPastShifts[areaId]) {
        return this.areaWeeksList[areaId].map(week => this.selectedPastShifts[areaId][week]).filter(result => result).flat()
      }
      return []
    },

    async handleUpdateShiftTime() {
      const shift = this.selectedShift
      const update = {
        state: 'updated',
        content: [
          `end: ${shift.endStr}`,
          `start: ${shift.startStr}`,
        ],
        processer: `${this.processer.firstName} ${this.processer.lastName}`,
        date: new Date(),
      }
      const updates = [...shift.updates, update]
      const start = new Date(shift.start)
      const end = new Date(shift.end)
      await this.updateShift({
        id: shift.id,
        updates: {
          updates, start, end, endStr: shift.endStr, startStr: shift.startStr,
        },
      })
      this.shiftPastList = this.shiftPastList.map(s => {
        if (shift.id === s.id) {
          return shift
        }
        return s
      })
    },

    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },

    resetModal() {
      this.formVerifiedShifts = {
        areaId: null,
        shiftId: null,
        data: [],
        emails: [],
      }
    },

  },
}
</script>

<style scoped>
  .header-container {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
  }
  .header-title {
    font-size: 16px;
  }
  .btn-confirm {
    max-height: 38px;
  }
  .capitalized {
    text-transform: capitalize;
  }
</style>
